<template>
  <div class="view">
    <div class="content">
      <div class="auth_item" v-if="authorizationInfo">
        <div class="authorizationBody mb-20">
          <div class="authorization_list">
            <div class="authorization_list_span">小程序名称</div>
            <div class="authorization_list_info">
              {{authorizationInfo.nick_name?authorizationInfo.nick_name:'暂无信息'}}
              <el-tooltip placement="right" effect="light" v-if="authorizationInfo.nickname_audit==0">
                <div slot="content" class="infocontent">
                  已授权小程序的名称，若在微信小程序进行过修改
                  <br>请点击下面的“刷新”同步最新的名称
                </div>
                <i class="iconfont iconbangzhu1"></i>
              </el-tooltip>
              <div v-if="authorizationInfo.nickname_audit!==0">
                ({{authorizationInfo.nickname_audit==1?'审核中':'审核失败'}})
                <el-tooltip placement="right" effect="light" v-if="authorizationInfo.nickname_audit==2">
                  <div slot="content" class="infocontent">
                    {{authorizationInfo.fail_reason}}
                  </div>
                  <i class="iconfont iconbangzhu1"></i>
                </el-tooltip>
              </div>
              <div>
                APPID:{{authorizationInfo.appid}}
              </div>
            </div>
            <div class="authorization_list_span">小程序头像</div>
            <div class="authorization_list_info status_img_body">
              <img :src="authorizationInfo.head_image_url" alt=""
                   v-if="authorizationInfo.head_image_url">
              <img src="@/assets/imgs/defultbg2@3x.png" alt="" v-else>
              <el-tooltip placement="right" effect="light">
                <div slot="content" class="infocontent">
                  已授权小程序的头像，若在微信小程序进行过修改
                  <br>请点击下面的“刷新”同步最新的头像
                </div>
                <i class="iconfont iconbangzhu1"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="authorization_list">
            <div class="authorization_list_span">微信认证</div>
            <div class="authorization_list_info">
              {{authorizationInfo.qualification_verify==1?'已认证':'未认证'}}
            </div>
            <div class="authorization_list_span">小程序功能介绍</div>
            <div class="authorization_list_info">
              {{authorizationInfo.signature_info?authorizationInfo.signature_info:'暂无数据'}}
            </div>
          </div>
          <div class="authorization_list">
            <div class="authorization_list_span">服务类目</div>
            <div class="authorization_list_info">
              <div v-if="authorizationInfo.service_cate">
                <p v-for="(item,index) in authorizationInfo.service_cate" :key="index"><span>{{item.first_name}}</span><span> -> {{item.second_name}}</span>
                </p>
              </div>
              <div v-else>暂无数据</div>
            </div>
            <div class="authorization_list_span">主体信息</div>
            <div class="authorization_list_info">
              {{authorizationInfo.principal_name?authorizationInfo.principal_name:'暂无数据'}}
            </div>
          </div>
          <!-- v-if="authorizationInfo.is_show==1" -->
          <div class="authorization_list_bottom_status">
            <div class="authorization_list_span">
              <span>小程序审核状态</span>
              <span>版本号：{{authorizationInfo.version}}</span>
            </div>
            <div class="authorization_list_info_check">
              <div class="authorization-new-list" v-for="(item,index) in authorizationInfo.version_progress" :key="index">
                <div class="authorization-new-list-left">
                  <span :class="index==0?'detelbg':''"></span>
                  <em></em>
                  <span :class="index==authorizationInfo.version_progress.length-1?'detelbg':''"></span>
                </div>
                <div class="authorization-new-list-right">
                  <div class="authorization-new-list-rightbox list-top-box defultImg" :class="[item.audit_status==0?'successImg':'',item.audit_status==1?'defultImg':'',item.audit_status==2||item.audit_status==3?'erroImg':'']">
                    <p>
                      <span v-if="item.audit_status==0">审核成功</span>
                      <span v-if="item.audit_status==1">提交审核</span>
                      <span v-if="item.audit_status==2">审核失败</span>
                      <span v-if="item.audit_status==3">重新提交审核</span>
                    </p>
                    <p>{{item.audit_time}}</p>
                  </div>
                  <div class="authorization-new-list-right-desc" v-html="item.reason"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- v-else -->
          <div class="authorization_list_bottom" >
            <div class="authorization_list_span">
              版本信息
            </div>
            <div class="authorization_list_info">
            <el-row :gutter="24">
              <el-col :span="11">
                <div class="grid-content">
                  <p class="mb-10"><strong>当前版本</strong></p>
                  <p class="mb-10">&nbsp;&nbsp;&nbsp;版本号：{{authorizationInfo.version_online || "体验版"}}</p>
                  <p class="mb-10 whd-ellipsis" v-if="!authorizationInfo.version_online">版本描述：{{authorizationInfo.user_desc || "暂无描述"}}</p>                  
                  <p class="mb-20">审核时间：{{!authorizationInfo.version_online?'待审核':authorizationInfo.audit_time}}</p>
                  <p v-if="authorizationInfo.versionStatus" style="padding-left: 70px">
                    <el-button type="success" plain round  @click="reflshStatusFn" :loading="reflshloading" style="border-radius: 15px; padding: 7px 23px;">{{authorizationInfo.version_online?'更新':'提交'}}</el-button> 
                  </p>     
                  <p class="mb-10">人脸核身状态：{{taskStatusResult}}</p> 
                  <p class="mb-10">小程序备案状态：{{applyStatusResult}}</p> 
                  <p>
                    <el-button size="small" @click.stop="sendFaceBody" type="primary" v-if="taskStatusResult != '核验成功'">
                      发起人脸核身
                    </el-button>
                    <el-button size="small" @click.stop="bindApplyRecord" type="primary">
                      申请备案
                    </el-button>
                    <el-button size="small" @click.stop="sendFaceBody" type="primary" v-if="taskStatusResult == '核验成功'">
                      重新发起人脸核身
                    </el-button>
                    <!-- <el-button size="small" @click.stop="bindTwoCode" type="primary">
                      获取二维码
                    </el-button> -->
                    <el-button size="small" @click.stop="bindGetCode" type="primary">
                      获取二维码
                    </el-button>
                    <el-button size="small" @click.stop="bindundocodeaudit" type="primary">
                      撤销审核
                    </el-button>
                  </p>           
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content">
                  <p class="mb-10"><strong>待上线版本</strong></p>
                  <p class="mb-10">&nbsp;&nbsp;&nbsp;版本号：
                    <template v-if="authorizationInfo.new_version_online != authorizationInfo.version">
                      {{authorizationInfo.new_version_online}}
                    </template>
                    <template v-else>暂无</template>                      
                  </p>
                  <p class="mb-10 whd-ellipsis">版本描述：
                    <template v-if="authorizationInfo.new_version_online != authorizationInfo.version">
                      {{authorizationInfo.new_version_desc}}
                    </template>
                    <template v-else>暂无</template>  
                  </p>
                  <p class="mb-20">审核时间：
                    <template v-if="authorizationInfo.new_version_online != authorizationInfo.version">
                      {{authorizationInfo.new_version_audit_time}}
                    </template>
                    <template v-else>暂无</template>                     
                  </p>
                  <p class="prompInfo">为避免被要求提交信息网络传播视听节目许可证，建议在提交审核时，暂时去除默认名片或官网中的视频内容。待审核通过后再行上传。 详情可查阅
                    <a href="https://url.cn/5XMpVOe" target="_blank" class="newa">《小程序开放的服务类目》</a></p>                  
                </div>
              </el-col>
            </el-row>  
            </div>         
          </div>
        </div>
        <div>
          <!--// company_type":"账号类型（0代小程序、1已有小程序授权）只有0才可以 修改小程序 按键-->
          <!--version_audit":"代码审核状态(0无审核、1审核中、2审核失败) 0/2 可以修改 修改小程序 按键-->
          <el-button size="small" @click.stop="editSettingBtn" type="primary">
            修改小程序信息
          </el-button>
          <!--version_audit":"代码审核状态(0无审核、1审核中、2审核失败) 2-->
          <el-button size="small" type="primary" v-if="authorizationInfo.version_audit==2" @click="reflshStatusFn">重新审核</el-button>
          <span @click.stop="RefreshFn" class="btn_right_rechBoxy"><i class="el-icon-refresh-right"></i>刷新</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  import myUpload from 'vue-image-crop-upload';
  import {yeartime, yeartime_day} from '@/assets/js/common'

  export default {
    name: "miniappPannel",
    components: {
      // myUpload
    },
    data() {
      return {
        reflshloading:false,
        authorizationInfo: null,
        addSttinename: false,
        dialogContent: '',
        // 裁剪
        show: false,
        headers: {
          smail: '*_~'
        },
        company_type: null,
        nowTime:yeartime_day(),
        taskStatusResult:'未开始',
        applyStatusResult:'未开始'
      };
    },
    created() {
      this.InitFn()
      this.getTaskStatus()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.company_authorization, {})
            .then(response => {
              if (response.data.code == 0) {
                if (response.data.info.service_cate === '[]') {
                  response.data.info.service_cate = []
                }
                response.data.info.audit_time = yeartime_day(response.data.info.audit_time)
                response.data.info.new_version_audit_time = yeartime_day(response.data.info.new_version_audit_time)
                // <!-- version_audit 为0状态 new_version_online 不为空大于 version_online-->
                // 判断是否显示更新
                let versionStatus = false
                // if (response.data.info.version_audit === 0) {
                  let str = response.data.info.new_version_online;
                  let new_str = response.data.info.version_online;
                  if (response.data.info.new_version_online && Number(str) > Number(new_str)) {
                    versionStatus = true
                  }
                // }
                if(response.data.info.version_progress){
                  for(let i in response.data.info.version_progress){
                    response.data.info.version_progress[i].audit_time = yeartime_day(response.data.info.version_progress[i].audit_time)
                  }
                }
                response.data.info.versionStatus = versionStatus
                this.authorizationInfo = response.data.info
                this.dialogContent = this.authorizationInfo.nick_name
                this.company_type = response.data.info.company_type
              } else {
              }
            })
            .catch(response => {
            });
      },
      RefreshFn() {
        this.axios
            .post(api.company_refresh, {})
            .then(response => {
              if (response.data.code == 0) {
                this.authorizationInfo.nick_name = response.data.info.nick_name
                this.authorizationInfo.head_image_url = response.data.info.head_image_url
                this.authorizationInfo.signature_info = response.data.info.signature_info
                this.authorizationInfo.service_cate = response.data.info.service_cate
                this.authorizationInfo.principal_name = response.data.info.principal_name
              } else {
              }
            })
            .catch(response => {
            });
      },
      editSettingBtn() {
        // this.$router.push('/miniappPannelEdit')
        this.$router.push({name: "miniappPannelEdit"});
      },
      //申请备案
      bindApplyRecord(){
        this.$router.push({name: "applyRecord"});
      },
      getTaskStatus(){
        this.axios
            .post(api.record_taskStatus, {})
            .then(response => {
              let {icpfiling_verify_result,apply_icpfiling_result} = response.data
              if(response.data.icp_task_id){
                if(icpfiling_verify_result == 0){
                  this.taskStatusResult = '核验中'
                }else if(icpfiling_verify_result == 2){
                  this.taskStatusResult = '核验失败'
                }else if(icpfiling_verify_result == 3){
                  this.taskStatusResult = '核验成功'
                }
              }
              if(apply_icpfiling_result == 2){
                this.applyStatusResult = '平台审核中'
              }else if(apply_icpfiling_result == 3){
                this.taskStatusResult = '平台审核驳回'
              }else if(apply_icpfiling_result == 4){
                this.taskStatusResult = '管局审核中'
              }else if(apply_icpfiling_result == 5){
                this.taskStatusResult = '管局审核驳回'
              }else if(apply_icpfiling_result == 6){
                this.taskStatusResult = '已备案'
              }
            })
            .catch(response => {
            });
      },
      //发起人脸核身
      sendFaceBody(){
        this.axios
            .post(api.record_sendface, {})
            .then(response => {
              if (response.data.errcode == 0) {
                this.$message({
                  message: '发起成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      bindGetCode(){
        this.axios
            .post(api.company_qrcode, {})
            .then(response => {
              if (response.data.errcode == 0) {
                this.$message({
                  message: '发起成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      bindundocodeaudit(){
        this.axios
            .post(api.company_undocodeaudit, {})
            .then(response => {
              if (response.data.errcode == 0) {
                this.$message({
                  message: '撤销成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      bindTwoCode(){
        this.axios
            .post(api.company_getcode, {})
            .then(response => {
              if (response.data.errcode == 0) {
                this.$message({
                  message: '发起成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      reflshStatusFn(){
        // 需要判断是否请求接口进行验证 this.authorizationInfo.is_main 1 官方企业需要验证
        if(this.authorizationInfo.is_main === 1){
          this.$confirm(this.authorizationInfo.quota_times, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submitaudit()
          }).catch(() => {
          });
        }else{
          this.submitaudit()
        }
      },
      submitaudit(){
        const loading = this.$loading({
          lock: true,
          text: '更新中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.reflshloading = true
        this.axios
            .post(api.company_submit_audit, {})
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn();
              } else {
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton:false,
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
              }
              this.reflshloading = false
              loading.close();
            })
            .catch(response => {
            });
      }
    },
  };
</script>
<style>
  .newa{
    color:#63b1fc;
  }
  .warmsmall{
    padding-left:80px;
  }
</style>
